export const typeOptions = [
  {label: 'Categorie de produit', value: 0},
  {label: 'Tag descriptif', value: 1}
]

export const typeFormatter = (item, mode) => {
  let result = typeOptions.filter(option => option.value == item)[0]
  return mode ? result.label : result
}
